import { defaultColors } from '../../../Common/Services/contexts/ServicesChartsDataContext';
import { Donut } from '../../../Common/Charts/Donut';
import { useBasicSanitationChartsDataContext } from './hooks/useBasicSanitationChartsDataContext';

export const HasPipedWater = () => {
    const { chartData } = useBasicSanitationChartsDataContext();

    return (
        <Donut
            title={'Existência de Água Canalizada'}
            subtitles={chartData?.hasPipedWater?.map(
                (item) => item.description
            )}
            chartData={chartData?.hasPipedWater || []}
            colors={
                defaultColors.slice(0, chartData?.hasPipedWater?.length) ||
                []
            }
            height={350}
        />
    );
};
